<template>
  <div
    class="idle-overlay"
  >
    <div class="idle-modal">
      <div class="idle-modal-inner">
        <h4
          class="idle-modal__title"
          v-html="$t('terminal.index.dialog.idle.attention')"
        ></h4>
        <div
          class="excerpt"
          v-html="`
            ${$t('terminal.index.dialog.idle.excerpt.first')} <strong>${time/1000}</strong>
             ${$t('terminal.index.dialog.idle.excerpt.second')}`"
        ></div>
        <div
          class="timer"
          v-html="time/1000"
        ></div>

        <div
          class="abort btn btn-default"
          v-html="$t('terminal.index.dialog.idle.abort')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      time: 30000,
    };
  },
  async created() {
    // get & set settings
    this.settings = await this.FETCH_SETTINGS();
    if (this.settings) {
      this.time = this.settings.app.timeouts.terminalCountdown;
    }

    const timerId = setInterval(() => {
      this.time -= 1000;
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId);
      if (this.time < 1) {
        // logout user
        this.logoutUser();
        // clear interval
        clearInterval(timerId);
        // redirect to the welcome screen (screensaver)
        // this.$router.push('/');
        // redirect to home + reload app
        // window.location.assign('/');
        // if (this.$route.name === 'index') {
        //   const query = { ...this.$route.query };
        //   delete query.start;
        //   this.$router.replace({ query });
        //   this.$router.go(0);
        // } else {
        //   this.$router.push('/');
        // }
      }
    }, 1000);
  },
  methods: {
    ...mapActions([
      'clearCart',
    ]),

    async FETCH_SETTINGS() {
      await this.$store.dispatch('setSettings');
      return this.$store.getters.settings;
    },

    async logoutUser() {
      // clear cart
      await this.clearCart();

      const formData = new FormData();
      /**
       * Locale
       */
      formData.append('locale', localStorage.getItem('boxLang'));
      // Logout data
      await this.$http.post(`${localStorage.getItem('anybox_terminal_api_url')}/logout`, formData, {
        headers: {
          'X-Api-Key': `${localStorage.getItem('anybox_terminal_api_key')}`,
          Authorization: `Bearer ${localStorage.getItem('auth')}`,
        },
      })
        .then((response) => {
          if (response.data) {
            // mutating to store for client rendering &
            // saving token in cookie for server rendering
            this.$store.commit('SET_AUTH', null);
            localStorage.removeItem('auth');

            // mutating to store for client rendering &
            // saving user data in cookie for server rendering
            this.$store.commit('SET_USER', null);
            localStorage.removeItem('user');

            // clear other important data
            localStorage.removeItem('qrcodeActive');

            // clear client card nr.
            localStorage.removeItem('clientCardNr');
          }
        });
      // .catch((error) => {
      //   if (!error.response) {
      //     // network error
      //     this.errorStatus = 'Error: Network Error';
      //   } else {
      //     this.errorStatus = error.response.data;
      //     console.log(this.errorStatus);
      //   }
      // });
      // redirect to home + reload app
      window.location.assign('/');
    },
  },
};
</script>
